// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import '../theme/index.css'
import '@/assets/iconfont/iconfont.css'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import echarts from 'echarts'
import VueCookies from 'vue-cookies'
import qrcode from 'vue-qrcode2'
import VueClipboard from 'vue-clipboard2'
import {
  isPwa
} from "@/utils/tools";
import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
import less from 'less';

Vue.use(Toast);

Vue.use(less);

Vue.use(VueClipboard)

Vue.use(VueCookies);

Vue.use(ElementUI);

Vue.use(qrcode);

Vue.config.productionTip = false;

Vue.prototype.$echarts = echarts;

// 全局组件  - xxk
import appComponents from '@/components/global/index.js';
Vue.use(appComponents);

/**
 * 路由卫士
 */
router.beforeEach((to, form, next) => {

  //页面标题
  document.title = (to.meta.title ? to.meta.title + "-" : "") + "大白身份云服务";

  document.title = isPwa() ? "大白身份云服务" : (to.meta.title ? to.meta.title + "-" : "") + "大白身份云服务";

  //未登录
  if (to.meta.isLogin && !localStorage.getItem('LOGIN_USER')) {
    ElementUI.Message.error('您尚未登录, 请先进行登录操作');
    next('/login')
    return;
  }

  //无权限
  if (to.meta.isLogin && to.path !== '/desktop') {
    let loginUser = localStorage.getItem('LOGIN_USER');
    loginUser = JSON.parse(loginUser);
    let rootList = loginUser.authorities;
    let hasRoot = false;

    rootList.map(row => {
      if (to.path.indexOf(row.path) !== -1) hasRoot = true;
    });

    if (!hasRoot) {
      ElementUI.Message.error('抱歉, 您没有访问权限');
      next(form.path);
      return;
    }
  }

  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");